





























































Currency = require 'models/currency.coffee'

module.exports =
  name: 'currencies_calculator'
  data: ->
    left_amount: 1
    right_amount: 0
    left_currency: @$store.getters.default_currency
    right_currency: 'usd'
  computed:
    currencies: -> @$store.state.user.currencies
    user_currencies: ->
      account_currencies = _.uniq(_.map(@$store.getters.accounts, 'currency'))
      return HM.store.state.user.currencies.filter (currency) -> account_currencies.includes(currency.code)
    rate_to_usd: -> (currency) -> Math.round(1 / currency.rate_to_usd * 100) / 100
    inverted_rate_to_usd: -> (currency) -> Math.round(currency.rate_to_usd * 100) / 100
    rate_to_default_currency: -> (currency) =>
      Math.round(Currency.convert(1, @$store.getters.default_currency, currency.code) * 100) / 100
    inverted_rate_to_default_currency: -> (currency) => Math.round(1 / Currency.convert(1, @$store.getters.default_currency, currency.code) * 100) / 100
  mounted: ->
    @calculateRight()
  methods:
    close: -> @$emit('close')
    calculateRight: -> @right_amount = Math.round(Currency.convert(@left_amount, @left_currency, @right_currency) * 1000) / 1000
    calculateLeft:  -> @left_amount = Math.round(Currency.convert(@right_amount, @right_currency, @left_currency) * 1000) / 1000
